import React from 'react';
import ReactDOM from 'react-dom';
import 'antd/dist/antd.css';
import './scss/fontello.scss';
import './scss/sitebase.scss';

import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));
